/**
 * Tauri window-label constants.
 *
 * Deliberately dependency-free: importing a label here must never pull in the
 * Tauri window API (`@tauri-apps/api/window`). `auxiliary-windows.ts` re-exports
 * `MAIN_WINDOW_LABEL` (as `RPA_MAIN_WINDOW_LABEL`) and is imported widely —
 * including by code under test whose jest mocks evaluate at import time — so
 * keeping this module a leaf avoids forcing every one of those consumers to mock
 * the Tauri window API.
 */

/**
 * Label of the app's main window — matches `app.windows[].label === 'main'` in
 * `src-tauri/tauri.conf.json` (identical across the base/staging/production
 * configs). Single source of truth for "is this the main window?" checks across
 * the app (deep-link gating, RPA lifecycle, dictation hand-off, etc.).
 */
export const MAIN_WINDOW_LABEL = 'main';

/**
 * Label of the dictation widget's separate Tauri webview — matches
 * `WIDGET_LABEL` in `src-tauri/src/widget/mod.rs`.
 */
export const DICTATION_WIDGET_WINDOW_LABEL = 'dictation-widget';
